<script setup>
import { isEmpty } from 'lodash';
import { usuarios, utilsUsuarios } from 'cifra-api-js';
import { onBeforeMount, ref, watch } from 'vue';

const props = defineProps({
  usuario: { type: Object, required: true },
});

const info = ref({});
const hijos = ref([]);
const tutores = ref([]);

function getLabelGruposAlumno(alumno) {
  if (isEmpty(alumno.grupos)) {
    return null;
  }

  return alumno.grupos.filter((grupo) => grupo.tipo === 'academico').map((grupo) => (
    grupo.etiqueta
  )).join(', ');
}

function cargarUsuario() {
  usuarios.show(
    props.usuario.id,
    { params: { info_contacto: true } },
  ).then((result) => {
    const { data } = result;
    info.value = data;
    info.value.label_grupo = getLabelGruposAlumno(data);
    hijos.value = data.tutelados.map((alumno) => {
      alumno.label_grupo = getLabelGruposAlumno(alumno);
      return alumno;
    });
    tutores.value = data.parentescos.filter((p) => p.tutor).map((p) => p.usuario);
  });
}

onBeforeMount(cargarUsuario);
watch(() => props.usuario, cargarUsuario);

</script>

<template>
  <div class="popover-usuario p-sm">
    <div class="header">
      <div class="text-center">
        <img
          :src="usuario.foto_url"
          class="usuario-thumbnail usuario-thumbnail-md img-circle img-thumbnail"
        />
      </div>
      <div class="p-l-sm info">
        <h3 class="p-b-md">
          {{ utilsUsuarios.fullname(usuario) }}
        </h3>
        <ul class="list-unstyled">
          <li v-if="info.telefono_movil">
            <span class="fas fa-fw fa-mobile-alt m-r-xs"></span>
            {{ info.telefono_movil }}
          </li>
          <li v-if="info.telefono_fijo">
            <span class="fa fa-fw fa-phone m-r-xs"></span>
            {{ info.telefono_fijo }}
          </li>
          <li v-if="info.email">
            <span class="fa fa-fw fa-envelope m-r-xs"></span>
            {{ info.email }}
          </li>
          <li v-if="info.label_grupo">
            <span class="fa fa-fw fa-users m-r-xs"></span>
            {{ info.label_grupo }}
          </li>
        </ul>
      </div>
    </div>
    <div v-if="hijos.length || tutores.length" class="parientes p-b-md">
      <hr>
      <div v-if="hijos.length">
        <h3 class="text-center">
          {{ $t('hijos') }}
        </h3>
        <div v-for="hijo in hijos" :key="hijo.id" class="hijo">
          <img
            :src="hijo.foto_url"
            class="usuario-thumbnail usuario-thumbnail-sm img-circle img-thumbnail"
          />
          <span class="nombre">
            {{ utilsUsuarios.fullname(hijo) }}
          </span>
          <span v-if="hijo.label_grupo" class="grupos">
            {{ hijo.label_grupo }}
          </span>
        </div>
      </div>
      <div v-if="tutores.length">
        <h3 class="text-center">
          {{ $t('tutores_legales') }}
        </h3>
        <div v-for="padre in tutores" :key="padre.id">
          <div class="header">
            <div class="text-center">
              <img
                :src="padre.foto_url"
                class="usuario-thumbnail usuario-thumbnail-sm img-circle img-thumbnail"
              />
            </div>
            <div class="p-l-sm info">
              <h3>
                {{ utilsUsuarios.fullname(padre) }}
              </h3>
              <ul class="list-unstyled">
                <li v-if="padre.telefono_movil">
                  <span class="fas fa-fw fa-mobile-alt m-r-xs"></span>
                  {{ padre.telefono_movil }}
                </li>
                <li v-if="padre.telefono_fijo">
                  <span class="fa fa-fw fa-phone m-r-xs"></span>
                  {{ padre.telefono_fijo }}
                </li>
                <li v-if="padre.email">
                  <span class="fa fa-fw fa-envelope m-r-xs"></span>
                  {{ padre.email }}
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
@import "@/../assets/stylesheets/cifra/vars/main.scss";
.popover-usuario {
  .header {
    display: flex;
  }

  .info {
    display: flex;
    flex-direction: column;

    ul li {
      white-space: nowrap;
    }
  }
  .parientes {
    hr {
      margin: 10px 0;
    }
    img {
      margin-right: $margin-sm;
    }
    .hijo {
      display: flex;
      .nombre {
        flex: 1;
      }
      .grupos {
        margin-left: $margin-md;
      }
    }
  }
}
</style>
